import { columnResizing } from './column-resize.js';
import { tableResizing as tableResizing$1 } from './table-resize.js';
import { rowResizing } from './row-resize.js';
export { tableColumnResizeKey, tableResizeKey, tableRowResizeKey } from './utils.js';

const tableResizing = () => [
    tableResizing$1(),
    columnResizing(),
    rowResizing()
];

export { tableResizing };
